/**
 * Google Maps places image holder finder and loader
 *
 * @package
 */

/**
 * Internal dependencies
 */
import replace from './replace';

/**
 * Load places images in any relevant .wp-block-stockistmap-place-image
 * child elements of the given element.
 *
 * @param {HTMLElement|Document|string}         element The element to search (default: document)
 * @param {HTMLDivElement|google.maps.Map|null} map     The element to apply attributions to (default: null)
 */
const apply = (
	element: HTMLElement | Document | string = document,
	map: HTMLDivElement | google.maps.Map | null = null
) => {
	if ( typeof element === 'string' ) {
		/**
		 * Element is a string, so create a temporary element to parse it
		 *
		 * @member	{HTMLDivElement}	parent	The temporary element
		 */
		const parent = document.createElement( 'div' );
		parent.innerHTML = element;

		element = parent.firstElementChild as HTMLElement;
	}

	/**
	 * Find all the places image elements
	 *
	 * @member	{NodeListOf<HTMLElement>}	elements	The elements
	 */
	const elements = element.querySelectorAll(
		'.wp-block-stockistmap-place-image'
	) as NodeListOf< HTMLElement >;

	// If there are any elements, replace them with the images
	if ( elements.length ) {
		replace( elements, map );
	}
};

export default apply;
